export default "__VITE_ASSET__NEfIvbd0__"